import { render, staticRenderFns } from "./Breadcrum.vue?vue&type=template&id=5cffa10c&scoped=true&"
import script from "./Breadcrum.vue?vue&type=script&lang=ts&"
export * from "./Breadcrum.vue?vue&type=script&lang=ts&"
import style0 from "./Breadcrum.vue?vue&type=style&index=0&id=5cffa10c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cffa10c",
  null
  
)

export default component.exports